import { Component, Input } from '@angular/core';
import { ServiceType } from '../mf-accounting-service.component';
import { SubscriptionUpdateReason } from '@web-frontend/shared/services/subscription';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'roma-mf-accounting-service-plan',
  templateUrl: './mf-accounting-service-plan.component.html',
  styleUrls: [],
})
export class MfAccountingServicePlanComponent {
  @Input()
  selectedPlan: ServiceType = ServiceType.regularPlans;

  @Input()
  updateReason: SubscriptionUpdateReason | null = null;

  @Input()
  fromUrl: string = window.location.pathname + window.location.search;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.updateReason = params['updateReason'];
      if (params['fromUrl']) {
        this.fromUrl = params['fromUrl'];
      }
    });
  }
}
